import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { SvgIcon } from "./Svg";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { fieldContainsValue, getDataType } from "../../controllers/common";
import { HtmlButton, HtmlAlert } from "./Html";
import "../../app/styles/components/ui/Modal.css";
import { Input, SelectInput } from "./form/Inputs";
import { addFreshLeadAPI, updateCrmLeadDetailsAPI } from "../../api/crm";
import { takeReadAbelError } from "../../controllers/readAbleError";
import { CRM_LEAD_SOURCE } from "../../shared/constants/Constants";
import { useNavigate } from "react-router-dom";

/** @deprecated  */
export default function ShowContentModal({
  open,
  close,
  element,
  title,
  width,
  style,
  className,
  loading,
  mask = false,
  maxHeight = "80vh",
  maskClosable = false,
  isAlertContains = false,
  alertObj = {},
  keyboard = true,
  actionElement,
  closable = true,
}) {
  const getWidth = () => {
    const width = window.innerWidth;
    if (width >= 1024) {
      return "50%"; // lg
    } else if (width >= 768) {
      return "70%"; // md
    } else if (width >= 640) {
      return "95%"; // sm
    } else {
      return "100%"; // default
    }
  };
  return (
    <Modal
      title={
        <div className="">
          <div className="">{title}</div>
          {isAlertContains && alertObj?.message && (
            <div className="w-full z-100">
              <HtmlAlert
                type={alertObj?.type}
                message={alertObj?.message}
                showIcon={alertObj?.showIcon ?? true}
              />
            </div>
          )}
          {actionElement && actionElement}
        </div>
      }
      open={open}
      onCancel={close}
      footer={null}
      centered
      style={{ minWidth: "300px", ...style }}
      bodyStyle={{ maxHeight: maxHeight, overflowY: "auto" }}
      width={width || getWidth()}
      className={`custom-modal ${className || ""}`}
      loading={loading}
      maskClosable={maskClosable}
      mask={mask}
      keyboard={keyboard}
      destroyOnClose={true}
      closable={closable}
    >
      {element}
    </Modal>
  );
}

/** @deprecated  */
export const HtmlAlertModal = ({
  okDisabled = false,
  cancelDisabled = false,
  okLoading = false,
  loading,
  title,
  message,
  cancelText,
  okText,
  okAction = () => {},
  cancelAction = () => {},
  open,
  close,
  maskClosable = false,
  alertType,
}) => {
  return (
    <div>
      <ShowContentModal
        title=""
        open={open}
        width={400}
        //   onClose={() => onBtnCancelTextClick()}
        closable={true}
        close={close}
        mask={true}
        maskClosable={maskClosable}
        element={
          <>
            <div className="items-center">
              {alertType ? (
                <div className="w-fit mx-auto ">
                  <SvgIcon
                    size={70}
                    color={(() => {
                      if (alertType === "error") {
                        return "red";
                      } else if (alertType === "success") {
                        return "green";
                      } else if (alertType === "warning") {
                        return "orange";
                      } else if (alertType === "info") {
                        return "#2196F3";
                      }
                    })()}
                    type={`${alertType}`}
                  />
                </div>
              ) : (
                ""
              )}
              <div
                aria-label="Loading..."
                role="status"
                class={` relative inset-0 flex justify-center  items-center space-x-2 ${
                  !loading ? "hidden" : ""
                }`}
              >
                <SvgIcon size={60} color="#2196F3" type="spinner" />
              </div>
              <h1 className="text-center m-auto font-bolder text-[24px] font-black mt-4 font-publicSans text-[#4B465C]">
                {title}
              </h1>

              <div className=" text-center mt-3 font-publicSans text-[#4B465C] ">{message}</div>

              {(cancelText || okText) && (
                <div className="flex justify-center pb-6 gap-5 mt-10 ">
                  {cancelText && (
                    <HtmlButton
                      disabled={cancelDisabled}
                      type="dark"
                      outline={true}
                      onClick={cancelAction}
                      text={cancelText}
                    />
                  )}
                  {okText && (
                    <HtmlButton
                      loading={okLoading}
                      disabled={okDisabled}
                      type="dark"
                      onClick={() => {
                        okAction();
                      }}
                      text={okText}
                    />
                  )}
                </div>
              )}
            </div>
          </>
        }
      />
    </div>
  );
};

/** @deprecated  */
export const DocumentPreview = ({
  add_another = true,
  url,
  setImagePreview = () => {},
  reUpload,
  documentName,
  addAnotherDisable = false,
  title = "", // type string
  downloadBtnDisabled = true,
  imageContainerStyle = {},
  onModalClose = () => {},
}) => {
  const [urls, setUrls] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [downloadImageUrl, setDownloadImageUrl] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

  function isPdfUrl(url) {
    if (!url) return false;
    if (getDataType(url) === "string" && url.toLowerCase().endsWith(".pdf")) {
      return true;
    }
    // must start with pdf mime type
    if (!url.startsWith("data:application/pdf;base64,")) {
      return false;
    }

    try {
      const cleaned = url.replace(/^data:application\/pdf;base64,/, "");
      const binary = atob(cleaned).slice(0, 4);
      return binary === "%PDF";
    } catch (e) {
      return false; // invalid base64
    }
  }
  const normalizeImageUrl = (imageUrl) => {
    if (Array.isArray(imageUrl)) {
      return imageUrl;
    } else if (typeof imageUrl === "string") {
      try {
        const parsedArray = JSON.parse(imageUrl);
        if (Array.isArray(parsedArray)) {
          return parsedArray;
        }
      } catch (e) {
        return [imageUrl];
      }
    } else {
      return [];
    }
  };
  useEffect(() => {
    if (fieldContainsValue(url)) {
      const normalUrls = normalizeImageUrl(url);
      const urlsArray = normalUrls
        ?.slice()
        ?.reverse()
        ?.filter((item) => item !== null && item !== undefined);
      setUrls(urlsArray);
      setDownloadImageUrl(urlsArray[0]);
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [url]);

  const handleLeftClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + urls.length) % urls.length);
    setDownloadImageUrl(urls[(currentIndex - 1 + urls.length) % urls.length]);
  };
  const handleRightClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % urls.length);
    setDownloadImageUrl(urls[(currentIndex + 1) % urls.length]);
  };

  const handleDownload = async () => {
    setDownloadBtnLoading(true);
    try {
      const response = await fetch(downloadImageUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = documentName ? documentName : "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("There was an error downloading the image:", error);
    } finally {
      setDownloadBtnLoading(false);
    }
  };
  return (
    <>
      <Modal
        title={title}
        open={isModalOpen}
        centered={true}
        footer={null}
        closable={true}
        onCancel={() => {
          setImagePreview("");
          setIsModalOpen(false);
          setUrls([]);
          onModalClose();
        }}
      >
        <div className="flex justify-center items-center ">
          <div className="bg-white rounded-md p-4 w-auto ">
            {urls.length > 0 && (
              <div
                className="flex relative h-auto flex-col items-center justify-center mb-0 pb-0 bg-gray-200 rounded-md custom-scrollbar"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  ...imageContainerStyle,
                }}
              >
                {!isPdfUrl(urls[currentIndex]) && (
                  <img
                    src={urls[currentIndex]}
                    alt="Img Preview"
                    className="w-full h-auto object-cover rounded-md"
                  />
                )}
                {isPdfUrl(urls[currentIndex]) && (
                  <div
                    className="mr-12 ml-12"
                    style={{
                      width: "350px",
                      height: "400px",
                      overflow: "auto",
                    }}
                  >
                    <iframe
                      key={urls[currentIndex]}
                      src={urls[currentIndex]}
                      title="PDF Viewer"
                      width="100%"
                      height="100%"
                      style={{ border: "none", margin: "auto" }}
                    ></iframe>
                  </div>
                )}

                {urls.length > 1 && isHovered && (
                  <button
                    className="w-[10%] h-full absolute left-0 bg-transparent hover:bg-opacity-5 text-gray-800 font-bold py-2 px-4 rounded-l"
                    onClick={handleLeftClick}
                  >
                    <div className="bg-gradient-to-r from-[#ffa940] to-[#ffa940] w-[20px] md:w-[30px] rounded-md">
                      <LeftOutlined />
                    </div>
                  </button>
                )}

                {/* Right Arrow */}
                {urls.length > 1 && isHovered && (
                  <button
                    className="w-[10%] h-full text-white absolute right-0 bg-transparent hover:bg-opacity-5 font-bold py-2 px-4 rounded-r"
                    onClick={handleRightClick}
                  >
                    <div className="bg-gradient-to-r -ml-[24px] md:-ml-[12px] from-[#ffa940] to-[#ffa940] w-[20px] md:w-[30px] rounded-md">
                      <RightOutlined />
                    </div>
                  </button>
                )}
              </div>
            )}
            <h3 className="my-2 font-bold text-center">
              {currentIndex + 1 + "/" + urls?.length} Image
            </h3>
            <div className={`flex justify-center gap-4 mt-2 `}>
              {add_another && (
                <HtmlButton
                  onClick={() => {
                    setImagePreview("");
                    reUpload();
                  }}
                  type={"save"}
                  svgType={"plus"}
                  disabled={addAnotherDisable}
                  text={"Add Another"}
                />
              )}
              {urls.length > 0 && (
                <HtmlButton
                  loading={downloadBtnLoading}
                  onClick={handleDownload}
                  type={"default"}
                  outline={true}
                  svgType={"download"}
                  text="Download"
                  disabled={downloadBtnDisabled}
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "#5537ff",
                    borderRadius: "24px",
                    color: "#5537ff",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

/** @deprecated  */
export const AddLeadModal = ({ onSuccess = () => {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [existingLeadDetails, setExistingLeadDetails] = useState({});
  const [alert, setAlert] = useState({ message: "", type: "" });
  const navigate = useNavigate();
  const closeAlert = () => {
    setAlert({ message: "", type: "" });
  };
  const isValidIndianPhone = (phone) => {
    return /^[6-9]\d{9}$/.test(phone); //validate an Indian phone number (10-digit, starting with 6/7/8/9):
  };
  const addFrehsLead = async () => {
    try {
      if (!fieldContainsValue(data?.phone)) {
        setAlert({ message: "Phone is required", type: "error" });
        return;
      }
      if (!fieldContainsValue(data?.source)) {
        setAlert({ message: "Source is required", type: "error" });
        return;
      }
      if (!fieldContainsValue(data?.name)) {
        setAlert({ message: "Name is required", type: "error" });
        return;
      }
      if (fieldContainsValue(data?.phone) && data?.phone?.length !== 10) {
        setAlert({ message: "Phone must be 10 digits", type: "error" });
        return;
      }
      if (!isValidIndianPhone(data?.phone)) {
        setAlert({ message: "Invalid phone number", type: "error" });
        return;
      }
      setIsLoading(true);
      const payload = {
        phone: data?.phone,
        source: data?.source,
        name: data?.name,
      };

      const result = await addFreshLeadAPI(payload);
      if (result.statusCode === 200) {
        const leadId = result?.results?.lead?.id;
        setAlert({ message: "Lead added successfully", type: "success" });
        setTimeout(() => {
          closeModal();
          onSuccess();
          navigate(`/details-page/lead/${leadId}`);
        }, 200);
      } else {
        throw "unable to add lead try again";
      }
    } catch (error) {
      let errorMessage = takeReadAbelError(error);
      if (error?.data?.message === "Lead already exists") {
        errorMessage = "Lead already exists. You can update the lead source.";
        setExistingLeadDetails(error?.data?.results);
      }
      if (error?.data?.message === "Lead already exists as Driver") {
        errorMessage = "Lead already exists as Driver";
      }

      setData({});
      setAlert({ message: errorMessage, type: "error" });
    }
    setIsLoading(false);
  };
  const updateExistingLead = async () => {
    setIsLoading(true);
    try {
      const result = await updateCrmLeadDetailsAPI(existingLeadDetails?.leadId, {
        source: data?.source,
      });
      if (result?.ok === true) {
        setAlert({ message: "Lead updated successfully", type: "success" });
        setTimeout(() => {
          closeModal();
          onSuccess();
          navigate(`/details-page/lead/${existingLeadDetails?.leadId}`);
        }, 200);
      } else {
        throw "unable to update lead try again";
      }
    } catch (error) {
      const message = takeReadAbelError(error);
      setAlert({ message: message, type: "error" });
    }
    setIsLoading(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setData({});
    closeAlert();
    setIsLoading(false);
    setExistingLeadDetails({});
  };
  return (
    <div>
      <HtmlButton
        text="Add Lead"
        type="save"
        onClick={() => {
          setIsModalOpen(true);
        }}
      />
      <ShowContentModal
        width={"auto"}
        title="Add Lead"
        open={isModalOpen}
        close={() => {
          closeModal();
        }}
        mask={true}
        element={
          <div>
            {fieldContainsValue(alert?.message) && (
              <HtmlAlert
                message={alert?.message}
                type={alert?.type}
                showIcon={true}
                onClose={closeAlert}
              />
            )}
            <div>
              {!existingLeadDetails?.leadId && (
                <div className="">
                  {" "}
                  <Input
                    name="name"
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }));
                    }}
                    value={data?.name}
                    title="Name"
                    mandatory={true}
                    placeholder={"Enter Name"}
                  />
                </div>
              )}
              {!existingLeadDetails?.leadId && (
                <Input
                  name="phone"
                  onChange={(e) => {
                    if (e.target.value.length > 10) {
                      return;
                    }
                    setData((prev) => ({
                      ...prev,
                      phone: e.target.value,
                    }));
                  }}
                  value={data?.phone}
                  title="Phone"
                  mandatory={true}
                  type="number"
                  min={0}
                  maxLength={10}
                  placeholder="Enter Phone Number"
                />
              )}

              <SelectInput
                name="source"
                title={"Source"}
                mandatory={true}
                options={CRM_LEAD_SOURCE}
                onChange={(value) => {
                  setData((prev) => ({
                    ...prev,
                    source: value,
                  }));
                }}
                value={data?.source}
              />
            </div>
            <div className="flex justify-end items-center gap-4">
              {existingLeadDetails?.leadId && (
                <HtmlButton
                  loading={isLoading}
                  disabled={isLoading}
                  type="dark"
                  outline={true}
                  svgType={"go-to-page"}
                  text="Details Page"
                  style={{
                    borderRadius: "30px",
                    height: "33px",
                  }}
                  onClick={() => {
                    navigate(`/details-page/lead/${existingLeadDetails?.leadId}`);
                  }}
                />
              )}
              <HtmlButton
                type="discard"
                text="Cancel"
                onClick={() => {
                  closeModal();
                }}
              />
              {!existingLeadDetails?.leadId && (
                <HtmlButton
                  onClick={addFrehsLead}
                  loading={isLoading}
                  disabled={isLoading}
                  type="save"
                  text="Save"
                />
              )}
              {existingLeadDetails?.leadId && (
                <HtmlButton
                  onClick={updateExistingLead}
                  loading={isLoading}
                  disabled={isLoading}
                  type="save"
                  text="Update"
                />
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};
/** @deprecated  */
export const MultipleImagePreviewModal = ({
  open,
  close,
  items = [], // Array of objects: [{ image: "url", number: "text", remarks: "text" (optional) }]
  title = "Images Preview",
  labelPrefix = "Number",
  labelPrefixRemarks = "Remark",
  width = "70%",
  noOfItemsPerRow = 2,
}) => {
  const [downloadLoading, setDownloadLoading] = useState({});
  const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to check if URL is a PDF
  const isPdfUrl = (url) => {
    if (!url) return false;
    const urlStr = typeof url === "string" ? url : String(url);

    // Check for .pdf extension
    if (urlStr?.toLowerCase()?.endsWith(".pdf")) {
      return true;
    }

    // Check for PDF in query params or fragments
    if (urlStr?.toLowerCase()?.includes(".pdf")) {
      return true;
    }

    // Check for data URL with PDF mime type
    if (urlStr?.startsWith("data:application/pdf")) {
      return true;
    }

    return false;
  };

  const handleDownloadSingle = async (imageUrl, itemNumber, index) => {
    setDownloadLoading((prev) => ({ ...prev, [index]: true }));
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) throw new Error("Download failed");
      const blob = await response.blob();

      // Determine file extension based on the URL or blob type
      let fileExtension = ".png"; // default
      if (isPdfUrl(imageUrl)) {
        fileExtension = ".pdf";
      } else if (blob.type) {
        // Extract extension from MIME type
        const mimeExtensions = {
          "image/jpeg": ".jpg",
          "image/jpg": ".jpg",
          "image/png": ".png",
          "image/gif": ".gif",
          "image/webp": ".webp",
          "application/pdf": ".pdf",
        };
        fileExtension = mimeExtensions[blob.type] || ".png";
      }

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${labelPrefix.replace(/\s+/g, "_")}_${itemNumber}_${index}${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setDownloadLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleDownloadAll = async () => {
    setDownloadAllLoading(true);
    try {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        try {
          const response = await fetch(item.image);
          if (!response.ok) continue;
          const blob = await response.blob();

          // Determine file extension based on the URL or blob type
          let fileExtension = ".png"; // default
          if (isPdfUrl(item.image)) {
            fileExtension = ".pdf";
          } else if (blob.type) {
            // Extract extension from MIME type
            const mimeExtensions = {
              "image/jpeg": ".jpg",
              "image/jpg": ".jpg",
              "image/png": ".png",
              "image/gif": ".gif",
              "image/webp": ".webp",
              "application/pdf": ".pdf",
            };
            fileExtension = mimeExtensions[blob.type] || ".png";
          }

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${labelPrefix.replace(/\s+/g, "_")}_${item.number}_${i}${fileExtension}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
          await new Promise((resolve) => setTimeout(resolve, 500));
        } catch (error) {
          console.error("Error downloading file:", error);
        }
      }
    } catch (error) {
      console.error("Error in download process:", error);
    } finally {
      setDownloadAllLoading(false);
    }
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImagePreview = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <div className="md:w-[70vw] w-[95vw]">
        {" "}
        <ShowContentModal
          title={title}
          open={open}
          close={close}
          // width="100%"
          maxHeight="90vh"
          mask={true}
          maskClosable={true}
          width="auto"
          element={
            <div className={`px-4 py-2 min-w-[350px] md:min-w-[800px] md:max-w-[800px]`}>
              {/* Images Grid */}
              <div
                className={`grid grid-cols-1 md:grid-cols-${noOfItemsPerRow ? noOfItemsPerRow : 2} gap-4 mb-6`}
              >
                {items?.map((item, index) => (
                  <div
                    key={index}
                    className="group relative bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-green-400 hover:shadow-2xl transition-all duration-300"
                  >
                    {/* Image/PDF Container */}
                    <div
                      className={`relative cursor-pointer bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center overflow-hidden ${noOfItemsPerRow ? "h-[60vh]" : ""}`}
                      onClick={() => handleImageClick(item.image)}
                    >
                      {!isPdfUrl(item.image) ? (
                        <img
                          src={item.image}
                          alt={`${labelPrefix} ${item.number}`}
                          className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/icons/error.svg";
                          }}
                        />
                      ) : (
                        <iframe
                          src={item.image}
                          title={`PDF ${labelPrefix} ${item.number}`}
                          className="w-full h-full border-none"
                          style={{ pointerEvents: "none" }}
                        />
                      )}
                      {/* Hover Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center">
                        <svg
                          className="w-12 h-12 text-white mb-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                          />
                        </svg>
                        <span className="text-white text-sm font-semibold">
                          Click to view full size
                        </span>
                      </div>
                    </div>

                    {/* Footer with Label and Download Button */}
                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-t border-gray-200">
                      {/* Top Row: Bill Number and Download Button */}
                      <div className="flex items-center justify-between px-4 py-3">
                        <div className="flex items-center gap-2">
                          <svg
                            className="w-5 h-5 text-green-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <p className="text-sm font-bold text-gray-800">
                            {labelPrefix}: <span className="text-green-600">{item.number}</span>
                          </p>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownloadSingle(item.image, item.number, index);
                          }}
                          disabled={downloadLoading[index]}
                          className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-xs font-semibold rounded-lg transition-all duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed shadow-md hover:shadow-lg"
                        >
                          {downloadLoading[index] ? (
                            <>
                              <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              <span>Downloading...</span>
                            </>
                          ) : (
                            <>
                              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                  fillRule="evenodd"
                                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              {/* <span>Download</span> */}
                            </>
                          )}
                        </button>
                      </div>

                      {/* Bottom Row: Remarks (Full Width) */}
                      {item.remarks && (
                        <div className="px-4 pb-3 pt-1 border-t border-green-100">
                          <div className="flex items-start gap-2">
                            <svg
                              className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                                clipRule="evenodd"
                              />
                            </svg>
                            <div className="flex-1">
                              <p className="text-sm font-bold text-gray-800 mb-0.5">
                                {labelPrefixRemarks}:{" "}
                                <span className="text-sm text-green-600 break-words ml-1">
                                  {item?.remarks ? item.remarks : "---"}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Show message if no items */}
              {(!items || items.length === 0) && (
                <div className="text-center py-12">
                  <svg
                    className="w-16 h-16 mx-auto text-gray-400 mb-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <p className="text-gray-500 font-medium">No images available</p>
                </div>
              )}

              {/* Download All Button - Centered at Bottom */}
              {items && items.length > 0 && (
                <div className="flex justify-center pt-4 pb-2 border-t border-gray-200">
                  <button
                    onClick={handleDownloadAll}
                    disabled={downloadAllLoading}
                    className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold rounded-full transition-all duration-300 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
                  >
                    {downloadAllLoading ? (
                      <>
                        <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        <span>Downloading All...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>Download All Documents</span>
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          }
        />
      </div>

      {/* Full Image/PDF Preview Modal */}
      {selectedImage && (
        <Modal
          open={!!selectedImage}
          onCancel={handleCloseImagePreview}
          footer={null}
          centered
          width="95%"
          style={{ maxWidth: "1400px" }}
        >
          <div className="flex justify-center items-center p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
            {!isPdfUrl(selectedImage) ? (
              <img
                src={selectedImage}
                alt="Full Preview"
                className="w-full h-auto object-contain rounded-lg shadow-2xl"
                style={{ maxHeight: "85vh" }}
              />
            ) : (
              <iframe
                src={selectedImage}
                title="PDF Full Preview"
                className="w-full rounded-lg shadow-2xl"
                style={{ height: "85vh", border: "none" }}
              />
            )}
          </div>
        </Modal>
      )}
    </>
  );
};
